export default {
  form: {
    bank_account_number: {
      label: 'Tilinumero',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Pankkitunnus',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'Maa',
      placeholder: 'Saksa',
    },
    bank_statement_descriptor: {
      label: 'Tiliotteen kuvaus',
      placeholder: 'Ravintolan nimi',
      tooltip: 'Tämä nimi näkyy asiakkaiden pankkiotteilla',
    },
  },
  buttons: {
    next: 'Seuraava',
    back: 'Takaisin',
    use_test_data: 'Käytä testitietoja',
  },
  test_data_hint: '{{gateways}}-yhteensopiva testipankkitili',
  read_only_warning: 'Pankkitietoja voi muuttaa vain tiimimme. Jos haluat päivittää ne, ota yhteyttä tukeen.',
};
